import {startWhichSizeVideo, utils, vh} from "./utils";
import {closePopupById, openPopupById} from "./popups";
import {goToByScroll} from "./go-to-by-scroll";

//let gsapMatchmedia = gsap.matchMedia();


// Initialize a new Lenis instance for smooth scrolling
const lenis = new Lenis({
	autoRaf: true,
});

// Listen for the 'scroll' event and log the event data to the console
/*lenis.on('scroll', (e) => {
	console.log(e);
});*/

// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
//lenis.on('scroll', ScrollTrigger.update);

// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
// This ensures Lenis's smooth scroll animation updates on each GSAP tick
/*gsap.ticker.add((time) => {
	lenis.raf(time * 1000); // Convert time from seconds to milliseconds
});*/

// Disable lag smoothing in GSAP to prevent any delay in scroll animations
//gsap.ticker.lagSmoothing(0);

startWhichSizeVideo(document.body);

const form = document.querySelector('.step--form .wpcf7');

/**
 * Create and array with all the fields and add the fields to the form
 * @type {*[]}
 */
let stepsArray   = [];
const steps      = document.querySelectorAll('.step');
const fieldsList = document.querySelector('.fields-list');

steps.forEach(function (step) {
	stepsArray.push({
		'title': step.dataset.fieldTitle,
		'name':  step.dataset.fieldName,
		'value': '',
	});
});

function updateProgress(value) {
	const progressText   = document.querySelector('.progress__value > span');
	const progressCircle = document.querySelector('.circular-progress');
	const progressLinear = document.querySelector('.linear-progress');
	const totalSteps     = document.querySelectorAll('.step:not(.step--skip)').length;
	const pastSteps      = document.querySelectorAll('.step--past:not(.step--skip)').length;

	if (value === undefined)
	{
		value = Math.ceil(pastSteps * 100 / totalSteps);
	}

	value = value.toString();

	progressText.textContent = value;
	progressCircle.style.setProperty('--progress', value);
	progressLinear.style.setProperty('--progress', value);
}

function updateFlow(fieldName) {
	const stepsArrayField = stepsArray.find(obj => obj.name === fieldName);

	if (stepsArrayField.name === 'utilizzo')
	{
		const stepDensitaCards  = document.querySelectorAll('.step[data-field-name="densita"] .card');
		const stepOcchiellatura = document.querySelector('.step[data-field-name="occhiellatura"]');
		const stepAntiscivolo   = document.querySelector('.step[data-field-name="antiscivolo"]');
		const stepManiglie      = document.querySelector('.step[data-field-name="maniglie"]');
		const inputSpessore     = document.querySelector('input[name="spessore"]');

		// se step Utilizzo = Protezioni, disabilitare valori Media e Bassa in step Densità
		stepDensitaCards.forEach(function (card) {
			const slide = card.parentNode;

			if (['Media', 'Bassa'].includes(card.dataset.value))
			{
				if (stepsArrayField.value === 'Protezioni')
				{
					slide.style.display = 'none';
				}
				else
				{
					slide.style.display = 'block';
				}
			}
		});

		// se step Utilizzo = Protezioni, abilitare step Occhiellatura
		// se step Utilizzo = Protezioni, disabilitare step Antiscivolo
		// se step Utilizzo = Protezioni, disabilitare step Maniglie
		// se step Utilizzo = Protezioni, spessore max = 10
		if (stepsArrayField.value === 'Protezioni')
		{
			stepOcchiellatura.classList.remove('step--skip');
			stepAntiscivolo.classList.add('step--skip');
			stepManiglie.classList.add('step--skip');
			inputSpessore.max = 10;
		}
			// se step Utilizzo != Protezioni, disabilitare step Occhiellatura
			// se step Utilizzo != Protezioni, abilitare step Antiscivolo
			// se step Utilizzo != Protezioni, abilitare step Maniglie
		// se step Utilizzo != Protezioni, spessore max = 40
		else
		{
			stepOcchiellatura.classList.add('step--skip');
			stepAntiscivolo.classList.remove('step--skip');
			stepManiglie.classList.remove('step--skip');
			inputSpessore.max = 40;
		}
	}

	if (stepsArrayField.name === 'forma')
	{
		const syncedStatusIcon = document.querySelector('.dimensioni-cards__sync');

		if (stepsArrayField.value === 'Quadrato')
		{
			syncEnabled = true;
			syncedStatusIcon.classList.add('dimensioni-cards__sync--synced');
		}
		else
		{
			syncEnabled = false;
			syncedStatusIcon.classList.remove('dimensioni-cards__sync--synced');
		}
	}

	if (stepsArrayField.name === 'tipologia')
	{
		const stepDensita = document.querySelector('.step[data-field-name="densita"]');

		// se step Tipologia = Solo rivestimento, disabilitare step Densità
		if (stepsArrayField.value === 'Solo rivestimento')
		{
			stepDensita.classList.add('step--skip');
		}
		else
		{
			stepDensita.classList.remove('step--skip');
		}
	}

	if (stepsArrayField.name === 'rivestimento')
	{
		const stepColoreCards = document.querySelectorAll('.step[data-field-name="colore"] .card');

		// se step Utilizzo = Protezioni, disabilitare valori Media e Bassa in step Densità
		stepColoreCards.forEach(function (card) {
			const finitura = card.dataset.finitura.split(',');
			const slide    = card.parentNode;

			if (
				(stepsArrayField.value === 'PVC lucido' && finitura.includes('lucido')) ||
				(stepsArrayField.value === 'PVC opaco' && finitura.includes('opaco')) ||
				(stepsArrayField.value === 'PVC carbon' && finitura.includes('carbon'))
			)
			{
				slide.classList.remove('disabled');
			}
			else
			{
				slide.classList.add('disabled');
			}
		});
	}

}


/**
 * Next step actions
 */
const btnsNextStep = document.querySelectorAll('.page-template-template-configuratore .btn-next-step');

btnsNextStep.forEach(function (btn) {

	btn.addEventListener('click', function () {
		const step        = btn.closest('.step');
		const nextStep    = utils.getNextSibling(step, '.step:not(.step--skip)');
		const message     = step.querySelector('.step__response');
		const isStepValid = step.dataset.stepValid;
		const fieldName   = step.dataset.fieldName;

		updateFlow(fieldName);

		// se lo step è validato
		if (isStepValid === 'true')
		{
			if (fieldName === 'maniglie')
			{
				updateManiglieValue();
			}

			if (fieldName === 'occhiellatura')
			{
				updateOcchiellaturaValue();
			}

			if (fieldName === 'quantita')
			{
				updateQuantitaValue();
			}

			// se non è l'ultimo step
			if (fieldName !== 'quantita')
			{
				// trasforma lo step corrente in uno step passato
				step.classList.remove('step--active');
				step.classList.add('step--past');

				// se ci sono altri step dopo lo step corrente, trasforma lo step successivo nello step corrente
				if (nextStep !== null)
				{
					nextStep.classList.remove('step--future');
					nextStep.classList.add('step--active');
				}
			}

			// nascondi il messaggio di errore
			message.style.display = 'none';
			goToByScroll(document.body, 0, 600);

			// aggiungi il campo dello step corrente al riepilogo
			const stepsArrayField = stepsArray.find(obj => obj.name === fieldName);

			let fieldsListField = fieldsList.querySelector('[data-field-name="' + fieldName + '"]');

			if (fieldsListField === null)
			{
				fieldsListField                   = document.createElement('div');
				fieldsListField.dataset.fieldName = fieldName;
			}

			fieldsListField.innerHTML = '<strong>' + stepsArrayField.title + '</strong><span>' + stepsArrayField.value + '</span>';
			fieldsList.appendChild(fieldsListField);

			// se è l'ultimo step apri il popup del riepilogo e mostra il bottone Prosegui
			if (fieldName === 'quantita')
			{
				openPopupById('popup-riepilogo');

				document.querySelector('#popup-riepilogo .btn').style.display = 'inline-flex';
			}

			updateProgress();

			// trigger gtag event
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event:  'configuratore',
				step:   fieldName,
				valore: stepsArrayField.value
			});
		}
		else
		{
			message.style.display = 'block';
			goToByScroll(message);
		}
	});

});


/**
 * Previous step actions
 */
const btnsPrevStep = document.querySelectorAll('.page-template-template-configuratore .btn-prev-step');

btnsPrevStep.forEach(function (btn) {

	btn.addEventListener('click', function () {

		if (btn.classList.contains('btn-back-to-forma-step'))
		{
			backToFormaStep();
			return false;
		}

		const step      = btn.closest('.step');
		const prevStep  = utils.getPreviousSibling(step, ':not(.step--skip)');
		const message   = step.querySelector('.step__response');
		const fieldName = step.dataset.fieldName;

		// invalida lo step
		step.dataset.stepValid = '';

		// nascondi il messaggio di errore
		if (message !== null)
		{
			message.style.display = 'none';
		}

		// trasforma lo step corrente in uno step futuro
		step.classList.remove('step--active');
		step.classList.add('step--future');

		if (fieldName !== '')
		{
			let fieldsListField = fieldsList.querySelector('[data-field-name="' + fieldName + '"]');

			if (fieldsListField !== null)
			{
				fieldsListField.remove();
			}

			// rimuove il valore dal campo del form
			removeValue(fieldName);
		}

		// rimuove lo stato attivo dalla card scelta
		const activeCard = step.querySelector('.card.active');

		if (activeCard !== null)
		{
			activeCard.classList.remove('active');
		}

		// reset valori input number
		const numberInputs = step.querySelectorAll('input[type="number"]');

		if (numberInputs.length > 0)
		{
			numberInputs.forEach(input => {
				if (input.min !== '' && !input.parentNode.classList.contains('input-wrapper--typed'))
				{
					input.value = input.min;
				}
				else
				{
					input.value = '';
				}
			});

			// imposta come sempre validi questi step
			if (['maniglie', 'occhiellatura', 'quantita'].includes(fieldName))
			{
				step.dataset.stepValid = 'true';
			}
		}

		// reset checkbox
		const checkboxInputs = step.querySelectorAll('input[type="checkbox"]');

		if (checkboxInputs.length > 0)
		{
			checkboxInputs.forEach(input => {
				if (input.value === 'Nessuno')
				{
					input.checked = true;
					input.dispatchEvent(new Event('change', {bubbles: true}));
				}
				else
				{
					input.checked = false;
					input.dispatchEvent(new Event('change', {bubbles: true}));
				}
			});

			step.dataset.stepValid = 'true';
		}

		// se ci sono altri step prima dello step corrente, trasforma lo step precedente nello step corrente
		if (prevStep !== null)
		{
			prevStep.classList.remove('step--past');
			prevStep.classList.add('step--active');
		}

		updateProgress();
	});

});


/**
 * Button .btn-open-form-step actions
 */
const btnOpenFormStep = document.querySelector('.btn-open-form-step');

if (btnOpenFormStep !== null)
{
	btnOpenFormStep.addEventListener('click', function () {
		// chiude #popup-riepilogo
		closePopupById('popup-riepilogo');

		const step     = document.querySelector('.step[data-field-name="quantita"]');
		const nextStep = document.querySelector('.step--form');

		// trasforma lo step Quantità in uno step passato
		step.classList.remove('step--active');
		step.classList.add('step--past');

		// trasforma .step--form nello step corrente
		nextStep.classList.remove('step--future');
		nextStep.classList.add('step--active');

		// mostra testo .content-ordine e nasconde testo .content-richiesta
		nextStep.querySelector('.content-ordine').style.display    = 'block';
		nextStep.querySelector('.content-richiesta').style.display = 'none';

		updateProgress();
	});
}


/**
 * Button .btn-contattaci actions
 */
const btnContattaci = document.querySelector('.btn-contattaci');

if (btnContattaci !== null)
{
	btnContattaci.addEventListener('click', function () {

		const nextStep = document.querySelector('.step--form');

		// trasforma tutti gli step futuri in uno step passato, tranne .step--form
		document.querySelectorAll('.step--active, .step--future').forEach(function (step) {
			if (step !== nextStep)
			{
				step.classList.remove('step--active', 'step--future');
				step.classList.add('step--past');
			}
		});

		// trasforma .step--form nello step corrente
		nextStep.classList.remove('step--future');
		nextStep.classList.add('step--active');

		// nasconde testo .content-ordine e mostra testo .content-richiesta
		nextStep.querySelector('.content-ordine').style.display    = 'none';
		nextStep.querySelector('.content-richiesta').style.display = 'block';

		nextStep.querySelector('.btn-prev-step').classList.add('btn-back-to-forma-step');

		updateProgress();
	});
}

function backToFormaStep() {
	document.querySelector('.btn-back-to-forma-step').classList.remove('btn-back-to-forma-step');

	const currentStep = document.querySelector('.step--active');
	const stepForma   = document.querySelector('.step[data-field-name="forma"]');

	// trasforma lo step attivo in uno step futuro
	currentStep.classList.remove('step--active');
	currentStep.classList.add('step--future');

	// trasforma lo step Forma nello step corrente
	stepForma.classList.remove('step--past');
	stepForma.classList.add('step--active');

	let stepAfterStepForma = utils.getNextSibling(stepForma, '.step:not(.step--skip)');

	while (stepAfterStepForma)
	{
		stepAfterStepForma.classList.remove('step--past');
		stepAfterStepForma.classList.add('step--future');
		stepAfterStepForma = utils.getNextSibling(stepAfterStepForma, '.step:not(.step--skip)');
	}

	updateProgress();
}



function updateValue(fieldName, value) {
	const formField       = form.querySelector('[name="' + fieldName + '"]');
	const stepsArrayField = stepsArray.find(obj => obj.name === fieldName);

	value = value.replace(/(<([^>]+)>)/gi, ""); // strip html tags

	formField.value = stepsArrayField.value = value;
}

function removeValue(fieldName) {
	const formField       = form.querySelector('[name="' + fieldName + '"]');
	const stepsArrayField = stepsArray.find(obj => obj.name === fieldName);

	formField.value = stepsArrayField.value = '';
}


/**
 * Allow only numbers in input[type="number"]
 */
document.querySelectorAll('.input-wrapper--typed input[type="number"]').forEach(input => {
	input.addEventListener('keydown', function (e) {
		// Allow: backspace, delete, tab, escape, enter, arrows
		if (
			[46, 8, 9, 27, 13, 110, 190].includes(e.keyCode) ||
			(e.keyCode >= 35 && e.keyCode <= 40) // home, end, arrows
		)
		{
			return;
		}

		// Allow: Ctrl/cmd+A, C, V, X
		if (
			(e.ctrlKey || e.metaKey) &&
			['A', 'C', 'V', 'X'].includes(e.key.toUpperCase())
		)
		{
			return;
		}

		// Ensure it's a number key
		if (
			(e.keyCode < 48 || e.keyCode > 57) &&
			(e.keyCode < 96 || e.keyCode > 105)
		)
		{
			e.preventDefault();
		}
	});
});


/**
 * Change value of number inputs with buttons
 */
document.querySelectorAll('.input-wrapper--controls').forEach(container => {
	const input        = container.querySelector('input[type="number"]');
	const decrementBtn = container.querySelector('.input-wrapper__minus');
	const incrementBtn = container.querySelector('.input-wrapper__plus');

	const updateButtons = () => {
		const value = parseInt(input.value);
		const min   = parseInt(input.min);
		const max   = parseInt(input.max);

		if (value <= min)
		{
			decrementBtn.classList.add('disabled');
		}
		else
		{
			decrementBtn.classList.remove('disabled');
		}

		if (value >= max)
		{
			incrementBtn.classList.add('disabled');
		}
		else
		{
			incrementBtn.classList.remove('disabled');
		}

		input.dispatchEvent(new Event('input', {bubbles: true}));
	};

	decrementBtn.addEventListener('click', () => {
		input.stepDown();
		updateButtons();
	});

	incrementBtn.addEventListener('click', () => {
		input.stepUp();
		updateButtons();
	});

	// Initial update
	updateButtons();
});


/**
 * Sync/unsync dimensioni
 * @type {Element}
 */
const stepDimensioni = document.querySelector('.step[data-field-name="dimensioni"]');
let syncEnabled      = true;

if (stepDimensioni !== null)
{
	const altezzaInput   = document.querySelector('input[name="altezza"]');
	const larghezzaInput = document.querySelector('input[name="larghezza"]');

	let isSyncing = false;

	function syncInputs(source, target) {
		if (!syncEnabled || isSyncing)
		{
			return;
		}
		isSyncing          = true;
		target.value       = source.value;
		target.style.width = source.style.width;
		isSyncing          = false;
	}

	altezzaInput.addEventListener("input", () => syncInputs(altezzaInput, larghezzaInput));
	larghezzaInput.addEventListener("input", () => syncInputs(larghezzaInput, altezzaInput));
}


/**
 * Manage fields in slideshow cards
 */
const swiperCards = document.querySelectorAll('.page-template-template-configuratore .swiper .card');

swiperCards.forEach(function (swiperCard) {

	swiperCard.addEventListener('click', function () {
		const value     = swiperCard.dataset.value;
		const step      = swiperCard.closest('.step');
		const fieldName = step.dataset.fieldName;
		const message   = step.querySelector('.step__response');

		const otherSlides = utils.getSiblings(swiperCard.parentNode);

		otherSlides.forEach(el => {
			el.querySelector('.card').classList.remove('active');
		});

		swiperCard.classList.add('active');

		updateValue(fieldName, value);

		step.dataset.stepValid = 'true';

		message.style.display = 'none';
	});

});


/**
 * Manage fields in Dimensioni cards
 */
const dimesioniInputs = document.querySelectorAll('[data-field-name="dimensioni"] input[type="number"]');

dimesioniInputs.forEach(input => {

	input.addEventListener('input', function () {
		const fieldName = 'dimensioni';
		const step      = document.querySelector('.step[data-field-name=' + fieldName + ']');
		const message   = step.querySelector('.step__response');

		let value            = '';
		let dimensioniValues = [];

		dimesioniInputs.forEach(input => {
			if (input.value !== '' && input.value > 0)
			{
				dimensioniValues.push(input.value);
			}
		});

		if (dimensioniValues.length === 3)
		{
			message.style.display = 'none';

			step.dataset.stepValid = 'true';

			value = dimensioniValues.join(' x ');
		}
		else
		{
			step.dataset.stepValid = '';

			value = '';
		}

		updateValue(fieldName, value);
	});
});


/**
 * Manage fields in Maniglie cards
 */
const maniglieInputs = document.querySelectorAll('[data-field-name="maniglie"] input[type="number"]');

if (maniglieInputs.length > 0)
{
	updateManiglieValue(true);

	maniglieInputs.forEach(input => {
		input.addEventListener('input', function () {
			updateManiglieValue();
		});
	});
}

function updateManiglieValue(onlyValidate) {

	const fieldName = 'maniglie';
	const step      = document.querySelector('.step[data-field-name=' + fieldName + ']');

	if (onlyValidate)
	{
		step.dataset.stepValid = 'true';
		return;
	}

	let maniglieValues = [];

	maniglieInputs.forEach(input => {
		if (input.value !== '')
		{
			maniglieValues.push(input.value);
		}
	});

	maniglieValues[0] = 'A/C: ' + maniglieValues[0];
	maniglieValues[1] = 'B/D: ' + maniglieValues[1];

	updateValue(fieldName, maniglieValues.join(', '));
}


/**
 * Manage fields in Occhiellatura cards
 */
const occhiellaturaInputs = document.querySelectorAll('[data-field-name="occhiellatura"] input[type="checkbox"]');

if (occhiellaturaInputs.length > 0)
{
	updateOcchiellaturaValue(true);

	occhiellaturaInputs.forEach(input => {
		input.addEventListener('input', function () {

			if (input.value === 'Nessuno' && input.checked)
			{
				occhiellaturaInputs.forEach(el => {
					if (el !== input)
					{
						el.checked = false;
						el.dispatchEvent(new Event('change', {bubbles: true}));
					}
				});
			}
			else
			{
				const occhiellaturaInputsNessuno = document.querySelector('[data-field-name="occhiellatura"] input[value="Nessuno"]');

				occhiellaturaInputsNessuno.checked = false;
				occhiellaturaInputsNessuno.dispatchEvent(new Event('change', {bubbles: true}));
			}

			updateOcchiellaturaValue();
		});
	});
}

function updateOcchiellaturaValue(onlyValidate) {

	const fieldName = 'occhiellatura';
	const step      = document.querySelector('.step[data-field-name=' + fieldName + ']');

	if (onlyValidate)
	{
		step.dataset.stepValid = 'true';
		return;
	}

	let occhiellaturaValues = [];

	occhiellaturaInputs.forEach(input => {
		if (input.checked)
		{
			occhiellaturaValues.push(input.value);
		}
	});

	updateValue(fieldName, occhiellaturaValues.join(', '));

	step.dataset.stepValid = 'true';
}


/**
 * Manage fields in Quantità cards
 */
const quantitaInput = document.querySelector('[data-field-name="quantita"] input[type="number"]');

if (quantitaInput !== null)
{
	updateQuantitaValue(true);

	quantitaInput.addEventListener('input', function () {
		updateQuantitaValue();
	});
}

function updateQuantitaValue(onlyValidate) {
	const fieldName = 'quantita';
	const step      = document.querySelector('.step[data-field-name=' + fieldName + ']');

	if (onlyValidate)
	{
		step.dataset.stepValid = 'true';
		return;
	}

	updateValue(fieldName, quantitaInput.value);
}


/**
 * Focus on the input when clicking a .card--number
 */
const cardsNumber = document.querySelectorAll('.card--number');

cardsNumber.forEach(function (card) {
	card.addEventListener('click', function () {
		const input = card.querySelector('input');

		if (input.parentNode.classList.contains('input-wrapper--typed'))
		{
			input.focus();
		}
	});
});


/**
 * Show success message and hide form after email is sent
 */
if (form !== null)
{
	form.addEventListener("wpcf7mailsent", function (el) {
		let hideOnSuccess  = document.querySelector('.step--form .hide-on-success');
		let successMessage = document.querySelector('.step--form .success-message');

		hideOnSuccess.style.display  = 'none';
		successMessage.style.display = 'block';

		updateProgress(100);
	});
}


/**
 * Confirm on page closing
 */
if (document.body.classList.contains('page-template-template-configuratore'))
{
	window.addEventListener('beforeunload', function (e) {
		if (!document.body.classList.contains('popup-open') && !document.querySelector('.step--form').classList.contains('step--active'))
		{
			e.preventDefault();
		}
	});
}


/**
 * Confirm on page exit
 */
if (document.body.classList.contains('page-template-template-configuratore'))
{
	document.querySelectorAll('a').forEach(link => {
		link.addEventListener('click', (e) => {
			const currentUrl = window.location.href;
			const linkUrl    = link.href;
			const linkHref   = link.getAttribute('href');

			if (document.querySelector('.step--form').classList.contains('step--active'))
			{
				return true;
			}

			if (linkHref === 'javascript:;' || linkHref === '#') // exclude links containing only "#"
			{
				return false;
			}

			if (linkUrl !== currentUrl && link.closest('#popup-exit') === null)
			{
				e.preventDefault();
				openPopupById('popup-exit');
			}
		});
	});
}


/**
 * Play/pause video bg
 */
const toggleVideo = document.querySelector('.toggle-video');

if (toggleVideo !== null)
{
	const videoBg = document.querySelector('.configura-bg');

	if (sessionStorage.getItem('playVideoBg') === 'true' || sessionStorage.getItem('playVideoBg') === null)
	{
		videoBg.play();
		sessionStorage.setItem('playVideoBg', 'true');
	}
	else
	{
		videoBg.pause();
		toggleVideo.classList.add('toggle-video--playing');
	}

	toggleVideo.addEventListener('click', function () {
		if (videoBg.paused)
		{
			videoBg.play();
			sessionStorage.setItem('playVideoBg', 'true');
			toggleVideo.classList.remove('toggle-video--playing');

		}
		else
		{
			videoBg.pause();
			sessionStorage.setItem('playVideoBg', 'false');
			toggleVideo.classList.add('toggle-video--playing');
		}
	});
}


function sanitizeValue(str) {
	// Normalize accented characters to their unaccented counterparts
	const normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

	// Replace spaces with dashes and convert everything to lowercase
	return normalizedStr.replace(/\s+/g, '-').toLowerCase();
}


/**
 * ON LOAD
 */

window.addEventListener('load', function (event) {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON RESIZE
 */

let prevWindowWidth = window.innerWidth;

window.addEventListener('resize', function (event) {
	if (event.target === window)
	{
		// trigger resizeEnd event only when the window resizing ends
		if (this.resizeTO)
		{
			clearTimeout(this.resizeTO);
		}
		this.resizeTO = setTimeout(function () {
			const event = new CustomEvent('resizeEnd');
			window.dispatchEvent(event);

			const windowWidth = window.innerWidth;

			if (windowWidth !== prevWindowWidth)
			{
				prevWindowWidth = windowWidth;

				const eventH = new CustomEvent('resizeHorizontallyEnd');
				window.dispatchEvent(eventH);
			}
		}, 200);
	}
});


/**
 * ON RESIZE END
 */

// do something when the window resizing ends
window.addEventListener('resizeEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});

window.addEventListener('resizeHorizontallyEnd', function () {

	//ScrollTrigger.getAll().forEach(t => t.refresh());

});


/**
 * ON SCROLL
 */
/*window.addEventListener('scroll', function() {
});*/